// extracted by mini-css-extract-plugin
module.exports = {"eventtimestamp_main_container":"EventTimestamp_eventtimestamp_main_container__3pudJ","per_hour":"EventTimestamp_per_hour__3bAUV","event_title":"EventTimestamp_event_title__tZ-Qm"};